import { Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import colors from 'helpers/colors'
import { FC, VFC } from 'react'

/**
 * @deprecated
 * リデザインでスタイルが変更されるので随時NewTitleに置き換えていく
 * TODO: 全て置き換えたら削除してNewTitleをTitleにリネームする
 */
const Title: VFC<{ title1: string; title2: string }> = ({ title1, title2 }) => {
  const screens = useBreakpoint()
  const xs = screens.xs

  return (
    <Typography.Title
      level={1}
      style={{ marginBottom: 0, fontWeight: 'unset' }}
    >
      <Typography.Text
        style={{
          fontSize: xs ? '20px' : '34px',
          fontWeight: 'lighter',
          lineHeight: 1,
          color: colors.grey30,
        }}
      >
        {title1}
      </Typography.Text>
      <Typography.Text
        style={{
          fontSize: xs ? '12px' : '14px',
          lineHeight: 1.4,
          color: colors.grey60,
          marginLeft: '8px',
        }}
      >
        /
      </Typography.Text>
      <Typography.Text
        style={{
          fontSize: xs ? '12px' : '14px',
          lineHeight: 1.4,
          color: colors.grey60,
          marginLeft: '8px',
        }}
      >
        {title2}
      </Typography.Text>
    </Typography.Title>
  )
}

type Props = {
  title1: string
  title2: string
}

export const NewTitle: FC<Props> = ({ title1, title2 }) => {
  return (
    <Typography.Title
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        paddingBottom: 24,
        borderBottom: `1px solid ${colors.border}`,
        color: colors.primary,
      }}
    >
      <Typography.Text style={{ fontSize: 32, lineHeight: 1, fontWeight: 400 }}>
        {title1}
      </Typography.Text>
      <Typography.Text style={{ fontSize: 14, lineHeight: 1, fontWeight: 400 }}>
        {`/ ${title2}`}
      </Typography.Text>
    </Typography.Title>
  )
}

export default Title
